export default __webpack_public_path__ + "static/media/Upload.721239ab.svg";